import { Link } from "react-router-dom";
import { FileText, Newspaper, Image as ImageIcon, Users } from "lucide-react";

const cards = [
  { to: "/admin/sivut", label: "Sivut", desc: "Muokkaa sivujen tekstejä", icon: FileText },
  { to: "/admin/blogi", label: "Blogi", desc: "Lisää ja muokkaa merkintöjä", icon: Newspaper },
  { to: "/admin/kuvat", label: "Kuvat", desc: "Lataa ja hallitse kuvia", icon: ImageIcon },
  { to: "/admin/kayttajat", label: "Käyttäjät", desc: "Lisää muokkaajia", icon: Users },
];

const Dashboard = () => (
  <div>
    <h2 className="mb-6 font-display text-2xl font-semibold">Tervetuloa hallintapaneeliin</h2>
    <div className="grid gap-4 sm:grid-cols-2">
      {cards.map(({ to, label, desc, icon: Icon }) => (
        <Link
          key={to}
          to={to}
          className="rounded-2xl border bg-card p-6 shadow-sm transition-transform hover:-translate-y-0.5"
        >
          <Icon className="mb-3 h-7 w-7 text-primary" />
          <h3 className="text-lg font-semibold">{label}</h3>
          <p className="text-sm text-muted-foreground">{desc}</p>
        </Link>
      ))}
    </div>
  </div>
);

export default Dashboard;
